var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.33281L11.872 5.50781L13.936 7.66615H5.8V9.33281H13.936L11.872 11.4828L13 12.6661L17 8.49948L13 4.33281ZM2.6 2.66615H9V0.999481H2.6C1.72 0.999481 1 1.74948 1 2.66615V14.3328C1 15.2495 1.72 15.9995 2.6 15.9995H9V14.3328H2.6V2.66615Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d6b29eea252af7d2aa0e340e9edfa2e1.svg";
export { ForwardRef as ReactComponent };